import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import { formatTimestampAsDate } from '../../../../utils/dates-utils';
import withStyles from '@material-ui/core/styles/withStyles';
import { createStyles } from '@material-ui/core';

const styles = createStyles(theme => ({
  licenseDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: 16,
    paddingBottom: theme.spacing(5),
    marginBottom: theme.spacing(5),
    borderBottom: '1px dashed grey',
    minWidth: '50%',
    width: '100%',
  },
}));

const LicenseDetails = React.forwardRef((props, ref) => {
  const { Version, AmountOfDaysHistory, HistoryStartDate } = props.user.LicenseInfo;
  const { classes } = props;
  
  return (
    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
      <h1>
        <FormattedMessage
          id="page.user-settings.license.details"
          defaultMessage="License details"
        />
      </h1>
      
      <div className={classes.licenseDetails}>
        <FormattedMessage
          id="page.user-settings.license.type"
          defaultMessage="License: {version}"
          values={{ version: <span style={{ fontWeight: 'bold' }}> {Version}</span> }}
          tagName="p"
        />
  
        <FormattedMessage
          id="page.user-settings.license.access"
          defaultMessage="Access to data {days} days back in time (from {startDate})"
          values={{
            days: (
              <span style={{ fontWeight: 'bold' }}>{AmountOfDaysHistory}</span>
            ),
            startDate: (
              <span style={{ fontWeight: 'bold' }}>
                  {formatTimestampAsDate(HistoryStartDate)}
              </span>
            ),
          }}
          tagName="p"
        />
      </div>
    </Box>
  );
});

const decorate = compose(withStyles(styles),
  connect(store => ({ user: store.user.profile })));
export default decorate(LicenseDetails);
